import { HTTP_METHODS } from "../constants/httpMethods";
import { apiService } from "./ApiService";
import { ApiResponse } from "../interfaces/responses/ApiResponse";
import { API_ENDPOINTS } from "../constants/apiEndpoints";

// Countries now live on HeavyDutyMachineryApi's own LocaleController.
const baseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || "";

export interface ICountryResponse {
    id: number;              // Numeric ID (unique identifier)
    name: string;            // Country name (e.g., "Afghanistan")
    alpha2Code: string;      // 2-character ISO country code (e.g., "AF")
    alpha3Code: string;      // 3-character ISO country code (e.g., "AFG")
    numericCode: number;     // Numeric code for the country (e.g., 4)
    currency: string;        // Currency name (e.g., "Afghan Afghani")
    currencyCode: string;    // ISO 4217 currency code (e.g., "AFN")
    languages: string[];     // List of languages spoken (e.g., ["Pashto", "Dari"])
  }
  

export const getCountries = async (): Promise<ICountryResponse[]> => {
  const response = await apiService<ApiResponse<ICountryResponse[]>>({
      url: API_ENDPOINTS.GET_COUNTRIES,
      method: HTTP_METHODS.GET,
      baseUrl: baseUrl,
  });

  if (response.success) {
      return response.data.data; 
  } else {
      throw new Error(response.error || "Failed to initiate payment");
  }
};

